//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import Cookies from "js-cookie";
import FeedbackMessage from "@/components/universal/FeedbackMessage";

export default {
  components: { FeedbackMessage },
  data() {
    return {
      avatarUrl: "",
      clipped: true,
      showSearch: false,
      drawer: true,
      fixed: true,
      miniVariant: false,
      fetched: false,
      id: "",
      initials: "",
      pictureCheck: false,
      title: "USTP Showreel",
      isTeacher: false,
      user: {
        loggedIn: false,
        firstName: "",
        lastName: "",
        personId: "",
        role: "",
        isAdmin: ""
      }
    };
  },
  created() {
    this.fetchInitialAvatar();
    if (!process.browser) return;
    this.drawer = window.innerWidth > 1263.98;
    if (Cookies.get("userId")) this.getUser();
  },
  watch: {
    showSearch(val) {
      let bar = document.getElementById("searchBar");
      if (val) {
        bar.animate([{ height: "0px" }, { height: "64px" }], {
          duration: 200,
          iterations: 1,
          easing: "ease-in-out"
        });
        bar.style.height = "64px";
      } else {
        bar.animate([{ height: "64px" }, { height: "0px" }], {
          duration: 200,
          iterations: 1,
          easing: "ease-in-out"
        });
        bar.style.height = "0px";
      }
    }
  },
  methods: {
    fetchInitialAvatar() {
      axios
        .get("/api/showreel-backend/public/api/user/profile", {
          params: { personId: Cookies.get("personId") }
        })
        .then((res) => {
          if (res.data.profile.profilePicture) {
            this.avatarUrl =
              "/api/showreel-backend/public/images/profilePicturesThumbnails/" +
              res.data.profile.profilePicture;
          } else {
            this.avatarUrl = "";
          }
          let name =
            res.data.profile.firstName + " " + res.data.profile.lastName;
          this.initials = name
            .split(" ")
            .map(function(item) {
              return item[0];
            })
            .join("");
          this.pictureCheck = res.data.permissions.find(
            (i) => i.permissionId === 2
          )
            ? true
            : false;
          this.isTeacher = res.data.profile.teacherId ? true : false;
          if (this.isTeacher) {
            this.pictureCheck = true;
          }
          this.fetched = true;
        })
        .catch((err) => {
          console.log(err);
          this.fetched = false;
        });
    },

    getUser() {
      this.user.loggedIn = true;
      this.user.firstName = Cookies.get("userFirstName");
      this.user.lastName = Cookies.get("userLastName");
      this.user.personId = Cookies.get("personId");
      this.user.role = Cookies.get("role");
      this.user.isAdmin = Cookies.get("isAdmin");

      const userJson = localStorage.getItem('user');
      if(!userJson){
        return;
      }

      const userInfo = JSON.parse(userJson);
      // Don't blame this crime on me, blame it on the garbage codebase that I have to work with
      this.user.isAdmin = userInfo.isAdmin ? '1' : '0';


    },
    async logout() {
      axios({
        method: "post",
        url: "/api/showreel-backend/public/api/logout"
      })
        .then((response) => {
          Cookies.remove("userId");
          Cookies.remove("userFirstName");
          Cookies.remove("userLastName");
          Cookies.remove("role");
          Cookies.remove("personId");
          Cookies.remove("isAdmin");
          localStorage.removeItem('user');
          this.drawer = false;
          this.$router.push("/");
        })
        .catch((err) => {
          console.log("Error");
        });
    }
  }
};
